var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-jumbotron',{staticClass:"increase-height",attrs:{"gradient":_vm.gradient}},[_c('v-container',{attrs:{"fill-height":""}},[_c('v-layout',{attrs:{"align-center":""}},[_c('v-flex',{attrs:{"text-xs-center":""}},[_c('h3',{staticClass:"display-3"},[_vm._v("No Path defined with this name or misspelled! ")])])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }